import React, { useContext, useState, useEffect } from 'react';
import Header from '../Header/AppHeader';
import Axiosfetch from '../Common/Axiosfetch';
import baseURL from '../Common/Config';
import moment from 'moment';
import Alert from 'react-s-alert';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/slide.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRupeeSign, faSearch } from '@fortawesome/free-solid-svg-icons';
import ReactTooltip from "react-tooltip";
import { ThemeContext } from '../Common/ThemeProvider';
import FailureAlert from '../Common/Failure';
//import SendSMS from '../Common/SMSService/MessageService';

const InvoiceApproval = () => {
    const { CurrentTheme } = useContext(ThemeContext);

    const [InvoiceData, setInvoices] = useState([]);
    const [displayValue, setDisplayValue] = useState("none");
    const [displayQuotationInfo, setdisplayQuotationInfo] = useState("none");
    const [QuotationsSnapShot, setQuotationsSnapShot] = useState({});
    const [SelectedinvoiceInfo, setSelectedinvoiceInfo] = useState([]);
    const [ProductOverView, setProductOverView] = useState([]);
    const [ProductOverViewQuantity, setProductOverViewQuantity] = useState([]);
    const [SelectedInvoice, setSelectedInvoice] = useState(0);
    const [RejectedReason, setRejectedReason] = useState("");
    const [TotalProducts, setTotalProducts] = useState(0);
    const [ExpectedQuantity, setExpectedQuantity] = useState(0);
    const [PaymentInfo, setPaymentInfo] = useState(0);
    const [FilterInvoice, setFilterInvoice] = useState([]);

    const FetchInvoices = () => {
        Axiosfetch(baseURL + "GetAllInvoicesByStatus", "POST", { Status: 1 }, InvoiceDataSuccess, Failure);
    };

    const OnReasonChange = (Value) => {
        setRejectedReason(Value);
    }

    const InvoiceDataSuccess = (data) => {
        if (data.length > 0) {
            setInvoices(data);
            setFilterInvoice(data);
        }
        else {
            setInvoices([]);
            setFilterInvoice([]);
        }
    };

    const Failure = (err) => {
        FailureAlert(err);
    };

    const hideQuotationInfo = () => {
        setdisplayQuotationInfo("none");
    };

    const hideInvoiceInfo = () => {
        setDisplayValue("none");
    };

    const FetchQuotationDetailsByID = (QuotationID) => {
        let quotationID = parseInt(QuotationID);
        Axiosfetch(baseURL + "QuotationSnapShotByID", "POST", { QuotationID: quotationID }, GetQuotationSnapShot, Failure);
    };

    const GetQuotationSnapShot = (data) => {
        if (data.length > 0) {
            setdisplayQuotationInfo("block");
            setQuotationsSnapShot(data[0]);
        }
        else {
            Alert.error("Quotation Snapshot not found. Generate PDF to get the snapshot", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
            setdisplayQuotationInfo("none");
            setQuotationsSnapShot({});
        }
    };

    const GetInvoiceInfo = (invoiceID, Quotation) => {
        setExpectedQuantity(Quotation.TotalQuantity);
        let selectedInvoiceInfo = InvoiceData.filter(i => i.ID === parseInt(invoiceID));
        if (selectedInvoiceInfo.length > 0) {
            setPaymentInfo(selectedInvoiceInfo[0].InvoiceCredit);
        }
        setSelectedInvoice(invoiceID);
        var ProductOverView = [];

        // eslint-disable-next-line array-callback-return
        Quotation.QuotationItems.map(qItems => {
            ProductOverView.push({ ID: qItems.ProductID, Name: qItems.Product.Name, Count: qItems.ProductQuantity });
        });

        setProductOverView(ProductOverView);

        Axiosfetch(baseURL + "GetCheckOutDetailsByInvoiceID", "POST", { InvoiceID: invoiceID }, GetInvoiceInfoSuccess, Failure);
    };

    const GetInvoiceInfoSuccess = (data) => {
        if (data.length > 0) {
            setDisplayValue("block");
            setSelectedinvoiceInfo(data);

            var ProductOverView = [];
            let productCount = 0;

            // eslint-disable-next-line array-callback-return
            data.map(productData => {
                GetProductOverView(productData, ProductOverView);
                productCount += productData.UpdatedQuantity;
            });

            setProductOverViewQuantity(ProductOverView);
            setTotalProducts(productCount);
        }
        else {
            Alert.error("No Checkout Items found.", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
            setDisplayValue("none");
            setSelectedinvoiceInfo([]);
        }
    };

    const GetProductOverView = (productData, ProductOverView) => {
        if (ProductOverView.length === 0) {
            ProductOverView.push({ ID: productData.Product.ID, Name: productData.Product.Name, Count: productData.UpdatedQuantity });
        }
        else {
            var productSearch = ProductOverView.filter(p => p.ID === productData.Product.ID);
            if (productSearch.length > 0) {
                var index = ProductOverView.indexOf(productSearch[0]);
                ProductOverView[index].Count = ProductOverView[index].Count + productData.UpdatedQuantity;
            }
            else {
                ProductOverView.push({ ID: productData.Product.ID, Name: productData.Product.Name, Count: productData.UpdatedQuantity });
            }
        }
    };

    const onRejectinvoice = () => {
        if (RejectedReason.trim() === "") {
            Alert.error("Please Select a Reason for Rejection.", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
        else {
            if (SelectedInvoice > 0) {
                Axiosfetch(baseURL + "DeleteCheckOutItemsByInvoiceID", "POST", { InvoiceID: SelectedInvoice }, DeleteCheckOutItemsSuccess, Failure);

            }
            else {
                Alert.error("Please Select a Reason for Rejection.", {
                    position: 'bottom-right',
                    effect: 'slide',
                    html: false
                });
            }
        }
    };

    const UpdateInvoiceSuccess = (data) => {
        if (data === "approved") {
            let selectedInvoiceInfo = InvoiceData.filter(i => i.ID === parseInt(SelectedInvoice));
            if (selectedInvoiceInfo.length > 0) {
                var InvoiceNumber = "Invoice/" + selectedInvoiceInfo[0].Quotation.Customer.Name.split(' ')[0].trim() + "/#" +
                    selectedInvoiceInfo[0].ID + "/" + moment(selectedInvoiceInfo[0].CreatedDate).local().format("DDMMYYYY");
                if (InvoiceNumber !== "") {
                    //SendSMS(selectedInvoiceInfo[0].Quotation.Customer.PhoneNumber, "Hi this is a test massage");
                    //SendSMS(919074355231, "Hi this is a test massage");
                }
            }

            Alert.success("Invoice Approved.", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
        else {
            Alert.success("Invoice Rejected.", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }

        FetchInvoices();
        setSelectedInvoice(0);
        setDisplayValue("none");
    };

    const DeleteCheckOutItemsSuccess = (data) => {
        if (data === "CheckOut Items Deleted Successfully") {
            Axiosfetch(baseURL + "ChangeInvoiceStatus", "POST", { ID: SelectedInvoice, Status: 3, Reason: RejectedReason, InvoiceCredit: 0 }, UpdateInvoiceSuccess, Failure);
        }
    }

    const onAcceptinvoice = () => {
        var getInvoiceProducts = [];
        let selectedInvoiceInfo = InvoiceData.filter(i => i.ID === parseInt(SelectedInvoice));
        if (selectedInvoiceInfo.length > 0) {
            // eslint-disable-next-line array-callback-return
            selectedInvoiceInfo[0].Quotation.QuotationItems.map(item => {
                getInvoiceProducts.push(item.Product.ID);
            });
        }

        var InvalidProduct = CheckIfItemsAreValid(getInvoiceProducts);
        if (InvalidProduct === "") {
            let paymentCredit = parseInt(PaymentInfo);
            if (paymentCredit > 0) {
                var userData = localStorage.getItem("userData") ? localStorage.getItem("userData") : null;
                var userID = (userData !== null) ? parseInt(JSON.parse(userData).ID) : 0;
                if (userID > 0) {
                    let BarCodeIDs = [];
                    let BarCodeIDsNull = [];

                    // eslint-disable-next-line array-callback-return
                    SelectedinvoiceInfo.map(product => {
                        if (product.ProductBarCode !== null) {
                            BarCodeIDs.push(product.ProductBarCode);
                        }
                        else {
                            BarCodeIDsNull.push(product.BatchProductID);
                        }
                    });

                    if (BarCodeIDs.length > 0) {
                        Axiosfetch(baseURL + "ProductInventoryOutByBarCodes", "POST",
                            {
                                InvoiceID: SelectedInvoice, OutData: moment(new Date()).toLocaleString(),
                                UserID: userID,
                                BarCodes: BarCodeIDs
                            }, CheckOutSuccess, Failure);
                    }

                    if (BarCodeIDsNull.length > 0) {
                        Axiosfetch(baseURL + "ProductInventoryOutByID", "POST", {
                            InvoiceID: SelectedInvoice,
                            OutData: moment(new Date()).toLocaleString(),
                            UserID: userID,
                            ID: BarCodeIDsNull
                        }, SaveDeviationQuantitySuccess, Failure);
                    }

                    UpDateInvoiceStatusAndRemoveCheckOut();

                }
                else {
                    Alert.error("Application Error. Please try again", {
                        position: 'bottom-right',
                        effect: 'slide',
                        html: false
                    });
                }
            }
            else {
                Alert.error("Please Select valid Credit option", {
                    position: 'bottom-right',
                    effect: 'slide',
                    html: false
                });
            }
        }
        else {
            Alert.error("Invoice linked Quotation does not contain Product -" + InvalidProduct, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const UpDateInvoiceStatusAndRemoveCheckOut = () => {
        if (SelectedInvoice > 0) {
            Axiosfetch(baseURL + "DeleteCheckOutItemsByInvoiceID", "POST", { InvoiceID: SelectedInvoice }, DeleteCheckOutItemsUpdateSuccess, Failure);
        }
        else {
            Alert.error("Please Select a Reason for Rejection.", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    }

    const DeleteCheckOutItemsUpdateSuccess = (data) => {
        if (data === "CheckOut Items Deleted Successfully") {
            Axiosfetch(baseURL + "ChangeInvoiceStatus", "POST", { ID: SelectedInvoice, Status: 2, Reason: RejectedReason, InvoiceCredit: parseInt(PaymentInfo) }, UpdateInvoiceSuccess, Failure);
        }
    };

    const CheckOutSuccess = (data) => {
        let BarCodeIDs = [];

        // eslint-disable-next-line array-callback-return
        SelectedinvoiceInfo.map(product => {
            // get all the records whose product Quantity and updated quantity has deviations
            if (product.ProductBarCode !== null && parseInt(product.Quantity) !== parseInt(product.UpdatedQuantity)) {
                BarCodeIDs.push(product.ProductBarCode);
            }
        });

        if (BarCodeIDs.length > 0) {
            Axiosfetch(baseURL + "GetBatchProductsByBarCodes", "POST", { BarCodes: BarCodeIDs, InvoiceID: SelectedInvoice }, BatchProductSuccess, Failure);
        }
    };

    const BatchProductSuccess = (data) => {
        if (data.length > 0) {
            var ProductValue = GetNewBatchProducts(false, data);
            if (ProductValue.length > 0) {
                Axiosfetch(baseURL + "CreateBatchProduct", "POST", ProductValue, CheckOutBarCodeIsNullSuccess, Failure);
            }
        }
    }

    const SaveDeviationQuantitySuccess = (data) => {
        CheckOutBarCodeNullSuccess(data);
    };

    const CheckOutBarCodeIsNullSuccess = (data) => {
        // No Logic
    };

    const CheckOutBarCodeNullSuccess = (data) => {

        let BatchProductIDs = [];

        // eslint-disable-next-line array-callback-return
        SelectedinvoiceInfo.map(product => {
            if (product.ProductBarCode === null && parseInt(product.Quantity) !== parseInt(product.UpdatedQuantity)) {
                BatchProductIDs.push(product.BatchProductID);
            }
        });

        if (BatchProductIDs.length > 0) {
            Axiosfetch(baseURL + "GetBatchProductsByBatchProductID", "POST", { BatchProductID: BatchProductIDs, InvoiceID: SelectedInvoice }, BatchProductIDsSuccess, Failure);
        }
    };

    const BatchProductIDsSuccess = (data) => {
        if (data.length > 0) {
            var ProductValue = GetNewBatchProducts(true, data);
            if (ProductValue.length > 0) {
                Axiosfetch(baseURL + "CreateBatchProduct", "POST", ProductValue, CheckOutBarCodeIsNullSuccess, Failure);
            }
        }
    };

    const GetNewBatchProducts = (IsProductNull, data) => {
        let BatchProductIDs = [];

        // eslint-disable-next-line array-callback-return
        SelectedinvoiceInfo.map(product => {
            if (IsProductNull) {
                if (product.ProductBarCode === null && parseInt(product.Quantity) !== parseInt(product.UpdatedQuantity)) {
                    BatchProductIDs.push(product);
                }
            }
            else {
                if (product.ProductBarCode !== null && parseInt(product.Quantity) !== parseInt(product.UpdatedQuantity)) {
                    BatchProductIDs.push(product);
                }
            }
        });

        var ProductValue = [];
        if (BatchProductIDs.length > 0) {

            // eslint-disable-next-line array-callback-return
            data.map(product => {
                var productData = IsProductNull ? BatchProductIDs.filter(p => p.BatchProductID === product.ID) :
                    BatchProductIDs.filter(p => p.ProductBarCode === product.ProductBarCode);

                if (productData.length > 0) {
                    ProductValue.push({
                        Quantity: parseInt(product.Quantity) - parseInt(productData[0].UpdatedQuantity),
                        BatchID: product.BatchID,
                        ProductBarCode: product.ProductBarCode,
                        ProductID: product.ProductID,
                        ProductInDate: product.ProductInDate,
                        ProductInBy: product.ProductInBy,
                        LoadingCost: product.LoadingCost,
                        UnLoadingCost: product.UnLoadingCost,
                        IsDamaged: product.IsDamaged,
                        IsDeleted: 0,
                        Status: 1
                    });
                }
            });
        }

        return ProductValue;
    };

    const getCreditPaymentDetails = (paymentInfo) => {
        setPaymentInfo(parseInt(paymentInfo));
    }

    const CheckIfItemsAreValid = (QuotationProducts) => {
        var productInfo = "";
        for (var i = 0; i < SelectedinvoiceInfo.length; i++) {
            if (!QuotationProducts.includes(SelectedinvoiceInfo[i].ProductID)) {
                productInfo = SelectedinvoiceInfo[i].Product.Name;
                break;
            }
        }

        return productInfo;
    };

    const onInvoiceSearch = (e) => {
        let searchValue = e.target.value;
        if (searchValue !== "") {
            let invoiceSearchData = InvoiceData.filter(c => c.Quotation.Customer.Name.toLowerCase().includes(searchValue.trim().toLowerCase()));
            setFilterInvoice(invoiceSearchData);
        }
        else {
            setFilterInvoice(InvoiceData);
        }
    };

    useEffect(() => {
        FetchInvoices();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (
        <div>
            <Header></Header>
            <div className="container-fluid InvoiceTheme sidemenu-show">
                <div className="row">
                    <div className="offset-md-3 col-md-6 col-sm-6">
                        <h5 className="align-center" style={{ fontWeight: "500", marginBottom: "15px" }}>Manage Invoices</h5>
                    </div>
                    <div className="col-md-3 col-sm-3" style={{ display: "flex" }}>
                        <input type="text" name="Name" placeholder="Search By Customer..."
                            className="form-control" style={{ marginRight: "10px", borderRadius: "20px", paddingLeft: "40px" }}
                            onChange={e => onInvoiceSearch(e)}></input>
                        <div className={`${CurrentTheme}Color`} style={{ fontSize: "1rem", position: "absolute", left: "9%", top: "17%" }}>
                            <FontAwesomeIcon icon={faSearch} />
                        </div>
                    </div>
                </div>
                <div className="PageHeight" style={{ marginTop: "5px" }}>
                    <div className="row" style={{ paddingRight: "12px" }}>
                        {
                            FilterInvoice.length > 0 && FilterInvoice.map(invoice => (
                                <div className="col-md-3 col-xs-12 col-sm-12" key={invoice.ID} style={{ marginBottom: "15px" }}>
                                    <div className="card cardMargin nonSelectable  CardhoverStyle align-center">
                                        <div onClick={(invoiceID) => GetInvoiceInfo(invoice.ID, invoice.Quotation)} className="card-header cursor">
                                            <div style={{ fontSize: "14px", paddingTop: "2px" }}>
                                                Invoice/{invoice.Quotation.Customer.Name.split(' ')[0].trim()}/#{invoice.ID}/{moment(invoice.CreatedDate).local().format("DDMMYYYY")}
                                            </div>
                                            <div data-tip={invoice.InterState === 1 ? "InterState" : "Local"} style={{
                                                position: "absolute", left: "95%", top: "-7px", backgroundColor: "#005582",
                                                width: "30px", borderRadius: "20px", color: "white", height: "30px", border: "2px solid white"
                                            }}>
                                                {invoice.InterState === 1 ? "S" : "L"}
                                            </div>
                                        </div>
                                        <div className="card-body">
                                            <div className="cursor" style={{ color: "#005582" }} onClick={() => FetchQuotationDetailsByID(invoice.Quotation.ID)} data-tip="Click to see Quotation Details">Quote/{invoice.Quotation.Customer ? invoice.Quotation.Customer.Name.split(' ')[0].trim() : ""}/#{invoice.Quotation.ID}/{moment(invoice.Quotation.CreatedDate).local().format("DDMMYYYY")}</div>
                                            <div style={{ marginTop: "5px" }} className="row">
                                                <div className="col-md-12 col-sm-12">
                                                    <ul className="list-group list-group-flush">
                                                        <li className="list-group-item liStyle">
                                                            <div className="row">
                                                                <div className="col-md-6 col-sm-6">
                                                                    <b>Quantity</b>
                                                                </div>
                                                                <div className="col-md-6  col-sm-6">
                                                                    <span className="font-size13rem">{invoice.Quotation.TotalQuantity}</span>
                                                                </div>
                                                            </div>
                                                        </li>
                                                        <li style={{ paddingTop: ".35rem" }} className="list-group-item liStyle">
                                                            <div className="row">
                                                                <div className="col-md-6  col-sm-6">
                                                                    <b>Amount</b>
                                                                </div>
                                                                <div className="col-md-6  col-sm-6">
                                                                    <FontAwesomeIcon className="font-size13rem" icon={faRupeeSign}></FontAwesomeIcon>
                                                                    <span className="font-size13rem"> {invoice.Quotation.TotalAmount}</span>
                                                                </div>
                                                            </div>
                                                        </li>
                                                        <li className="list-group-item">
                                                            <div className="row">
                                                                <div className="col-md-12  col-sm-12">
                                                                    {moment(invoice.CreatedDate).format('DD MMM YYYY, h:mm:ss A')}
                                                                </div>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <ReactTooltip></ReactTooltip>
                                </div>

                            ))
                        }
                        {
                            FilterInvoice.length === 0 ? (
                                <div className="col-md-12 col-sm-12 align-center">
                                    <h5 className="align-center" style={{ fontWeight: "400", marginBottom: "15px", position: "absolute", left: "32vw", top: "20vh" }}>There are No Invoice to Approve Or Reject.</h5>
                                </div>
                            ) : ""
                        }

                    </div>

                </div>
                <div id="myModalProductInfo" className="modal" style={{ display: displayValue }}>
                    <div className="modal-content">
                        <div className={`modal-header header-style align-center ${CurrentTheme}`}>
                            <span style={{ marginLeft: "5px", padding: "5px" }}>Product Checkout Information</span>
                            <span className="close" onClick={hideInvoiceInfo}>&times;</span>
                        </div>
                        <div className="ProductInfoHeightStyle" style={{ height: "45vh" }}>
                            <table className="table table-striped">
                                <thead>
                                    <tr>
                                        <th className={`align-center InvoicetitleStyle ${CurrentTheme}`}>SI No.</th>
                                        <th style={{ width: "250px" }} className={`align-center InvoicetitleStyle ${CurrentTheme}`}>Product</th>
                                        <th className={`align-center InvoicetitleStyle ${CurrentTheme}`}>Product BarCode</th>
                                        <th className={`align-center InvoicetitleStyle ${CurrentTheme}`}>Quantity</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {SelectedinvoiceInfo.length > 0 && SelectedinvoiceInfo.map((productInfo, index) => (
                                        <tr key={productInfo.ID}>
                                            <td className="align-center">{index + 1}</td>
                                            <td className="align-center">{productInfo.Product.Name}</td>
                                            <td className="align-center">{productInfo.ProductBarCode}</td>
                                            <td className="align-center">{productInfo.UpdatedQuantity}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div className="row" style={{ marginTop: "5px", marginBottom: "5px" }}>
                            <div className="col-md-12">
                                <table className="table table-bordered">
                                    <tbody>
                                        <tr style={{ borderBottom: "1px solid #dee2e6", textAlign: "center", backgroundColor: "#ddd", fontSize: "20px" }}>
                                            <td>
                                                Total Quantity
                                            </td>
                                            <td>
                                                <span style={{ marginRight: "10px", color: (TotalProducts < ExpectedQuantity || TotalProducts > ExpectedQuantity) ? "red" : "green" }}>{TotalProducts}</span>
                                                /<span style={{ marginLeft: "10px" }}>{ExpectedQuantity}</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="row" style={{ marginTop: "5px", marginBottom: "5px" }}>
                            <div className="col-md-12">
                                <table className="table table-bordered">
                                    <tbody>
                                        <tr style={{ borderBottom: "1px solid #dee2e6", backgroundColor: "#ddd" }}>
                                            <th style={{ textAlign: "left", border: "none" }} className={`align-center InvoicetitleStyle ${CurrentTheme}`}>Products</th>
                                            <th style={{ textAlign: "center", border: "none" }} className={`align-center InvoicetitleStyle ${CurrentTheme}`}>Count</th>
                                        </tr>
                                        {ProductOverView.length > 0 && ProductOverView.map(product => (
                                            <tr key={product.ID} style={{ borderBottom: "1px solid #dee2e6" }}>
                                                <td>
                                                    <span style={{
                                                        color: (ProductOverViewQuantity.filter(q => q.ID === product.ID).length > 0 ?
                                                            (ProductOverViewQuantity.filter(q => q.ID === product.ID)[0].Count < product.Count ? "red" : "green") : "red")
                                                    }}> {product.Name}</span>
                                                </td>
                                                <td style={{ textAlign: "center" }}>
                                                    <span style={{
                                                        color: (ProductOverViewQuantity.filter(q => q.ID === product.ID).length > 0 ?
                                                            (ProductOverViewQuantity.filter(q => q.ID === product.ID)[0].Count < product.Count ? "red" : "green") : "red")
                                                    }}>{ProductOverViewQuantity.filter(q => q.ID === product.ID).length > 0 ?
                                                        ProductOverViewQuantity.filter(q => q.ID === product.ID)[0].Count : 0}</span> /
                                                    <span style={{ marginLeft: "5px" }}>{product.Count}</span>
                                                </td>
                                            </tr>
                                        ))
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="row" style={{ marginTop: "5px" }}>
                            <div className="col-md-12">
                                <h5>Reason</h5>
                            </div>
                            <div className="col-md-12">
                                <textarea value={RejectedReason} onChange={(e) => OnReasonChange(e.target.value)} rows="1" className="form-control" style={{ width: "100%" }}></textarea>
                            </div>
                        </div>
                        <div className="row" style={{ marginTop: "10px" }}>
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-3 col-sm-3">
                                        <h5>Credit</h5>
                                    </div>
                                    <div className="col-md-9 col-sm-9 align-right">
                                        <div className="basic-select">
                                            <select className="DropdownStyle" style={{ width: "85%" }} value={PaymentInfo} onChange={(e) => getCreditPaymentDetails(e.target.value)}>
                                                <option value="0">Select Credit</option>
                                                <option value="1">Full Payment</option>
                                                <option value="2">Partial Payment</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row" style={{ marginTop: "15px" }}>
                            <div className="col-md-12 text-right">
                                <button type="button" className="btn btn-Save" style={{ cursor: (TotalProducts !== ExpectedQuantity || ProductOverViewQuantity.length !== ProductOverView.length) ? "not-allowed" : "pointer" }} disabled={TotalProducts !== ExpectedQuantity || ProductOverViewQuantity.length !== ProductOverView.length}
                                    onClick={onAcceptinvoice}
                                >
                                    Approve
                                </button>
                                <button type="button" className="btn btn-Reject"
                                    onClick={onRejectinvoice}
                                >
                                    Reject
                                </button>
                                <button type="button" className="btn btn-default"
                                    onClick={hideInvoiceInfo}
                                >
                                    Close
                                </button>

                            </div>
                        </div>
                    </div>
                </div>
                <div id="myModalQuotationInfo" className="modal" style={{ display: displayQuotationInfo }}>
                    <div style={{ width: "80%" }} className="modal-content">
                        <div className={`modal-header header-style align-center ${CurrentTheme}`}>
                            <span style={{ marginLeft: "5px", padding: "5px" }}>Quotation SnapShot</span>
                            <span className="close" onClick={hideQuotationInfo}>&times;</span>
                        </div>
                        <div className="row" style={{ marginTop: "10px", marginBottom: "10px" }}>
                            <div className="col-md-12 col-sm-12">
                                {
                                    QuotationsSnapShot.ImageData !== undefined && <img width="100%" src={QuotationsSnapShot.ImageData} alt="QuotationImage"></img>
                                }

                                {
                                    QuotationsSnapShot.ImageData === undefined && (<div className="offset-md-1 col-md-10 col-sm-10 align-center">No Quotation History Available</div>)
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InvoiceApproval;